import { LinkSmall } from "@wix/wix-ui-icons-common";
import { RICOS_ANCHOR_TYPE, RICOS_LINK_TYPE } from "./../ricos-content";
import {
  createShortcut,
  Decoration_Type,
  quickActionsModalSections,
  RicosPluginToolbarNames
} from "./../ricos-types";
import { openLinkModal } from "./../_shared/link-modal/open-link-modal";
import { toggleLinkModal } from "./../_shared/link-modal/toggle-link-modal";
import { LinkButton } from "./../toolbars-v3";
import { RESOLVERS_IDS } from "./../toolbars-v3/lib/resolvers-ids";
import { anchorConverter } from "./anchor-converter";
import { TEXT_BUTTON_LINK } from "./data-hooks";
import { DEFAULTS } from "./defaults";
import { getToolbarButtons } from "./get-toolbar-buttons";
import { linkConverter } from "./link-converter";
import LinkIcon from "./LinkIcon";
import { LINK_TYPE } from "./types";
const onSave = (publicCommands) => (linkData) => {
  publicCommands.insertDecoration(linkData.anchor ? RICOS_ANCHOR_TYPE : RICOS_LINK_TYPE, linkData);
};
const onSaveMultiple = (publicCommands) => (anchors) => {
  publicCommands.insertMultipleAnchors(anchors);
};
const onUnlink = (publicCommands) => (linkData) => {
  publicCommands.deleteDecoration(linkData.anchor ? RICOS_ANCHOR_TYPE : RICOS_LINK_TYPE);
};
const pluginLink = (config) => {
  const pluginConfig = { ...DEFAULTS.config, ...config };
  return {
    config: pluginConfig,
    type: LINK_TYPE,
    tiptapExtensions: [],
    pmNodeConverters: [],
    pmMarkConverters: [linkConverter, anchorConverter],
    shortcuts: [
      createShortcut({
        name: Decoration_Type.LINK,
        description: "ShortcutsSheet_Formatting_Link",
        group: "ShortcutsSheet_Section_Formatting",
        keys: {
          macOs: "Meta+K",
          windows: "Ctrl+K"
        },
        enabled: true,
        command: ({ publicCommands, modalService, editor }) => {
          openLinkModal({
            editor,
            initialValue: publicCommands.getLinkDataInSelection(),
            modalService,
            onSave: onSave(publicCommands),
            onSaveMultiple: onSaveMultiple(publicCommands),
            onUnlink: onUnlink(publicCommands),
            placement: "bottom-end"
          });
        }
      })
    ],
    toolbar: {
      names: [RicosPluginToolbarNames.LINK],
      getButtons: getToolbarButtons,
      isVisible: (selection, editor) => {
        const isSelectionCollapsed = (selection2) => {
          const { from, to } = selection2;
          return to - from <= 0;
        };
        const isCollapsed = isSelectionCollapsed(selection);
        const isLinkInSelection = editor.getPublicCommands().hasLinkInSelection();
        return isCollapsed && isLinkInSelection;
      }
    },
    textButtons: [
      {
        id: Decoration_Type.LINK,
        type: "modal",
        presentation: {
          dataHook: TEXT_BUTTON_LINK,
          tooltip: "TextLinkButton_Tooltip",
          icon: LinkIcon
        },
        attributes: {
          visible: RESOLVERS_IDS.ALWAYS_VISIBLE,
          active: RESOLVERS_IDS.IS_TEXT_CONTAINS_LINK_OR_ANCHOR,
          disabled: RESOLVERS_IDS.IS_NODE_SELECTED
        },
        Component: LinkButton,
        command: ({ publicCommands, modalService, referenceElement }) => () => {
          toggleLinkModal({
            initialValue: publicCommands.getLinkDataInSelection(),
            modalService,
            onSave: onSave(publicCommands),
            onSaveMultiple: onSaveMultiple(publicCommands),
            onUnlink: onUnlink(publicCommands),
            referenceElement
          });
          return true;
        }
      }
    ],
    getQuickActions: () => [
      {
        id: "link",
        title: "QuickActionsPlugin_ActionTitle_Link",
        icon: LinkSmall,
        section: quickActionsModalSections.FormatLayout,
        tags: ["link", "anchor", "url", "hyperlink"],
        command: ({ publicCommands, modalService, editor }) => {
          openLinkModal({
            editor,
            modalService,
            onSaveMultiple: onSaveMultiple(publicCommands),
            onSave: onSave(publicCommands),
            onUnlink: onUnlink(publicCommands),
            placement: "bottom-end"
          });
        }
      }
    ]
  };
};
export {
  pluginLink
};
//# sourceMappingURL=editor.js.map

import { injectCss } from "./viewer-styles-inject";
injectCss();
